export const getPriceChangeColorClassName = (price: number) => {
    if (price < 0) return 'text-error';
    return 'text-success';
}